<template>
  <div class="body-wrapper">
    <Header :title="'Challenges'" />
    <div class="challenge-filters tab-container">
      <ul class="tabs">
        <li 
          :class="{'selected': selectedCategory === 'all'}"
          @click="changeTab('all')">
            ALL
        </li>
        <li 
          :class="{'selected': selectedCategory === 'repeats'}"
          @click="changeTab('repeats')">
            M/Y REPEATS
        </li>
        <li 
          :class="{'selected': selectedCategory === 'performance'}"
          @click="changeTab('performance')">
            PERFORMANCE
        </li>
        <li 
          :class="{'selected': selectedCategory === 'social'}"
          @click="changeTab('social')">
            SOCIAL
        </li>
        <li 
          :class="{'selected': selectedCategory === 'exercise'}"
          @click="changeTab('exercise')">
            EXERCISE
        </li>
        <li 
          :class="{'selected': selectedCategory === 'weight'}"
          @click="changeTab('weight')">
            WEIGHT LIFTED
        </li>
      </ul>
      <div class="search-field">
        <input 
          type="text" 
          placeholder="Search..." 
          v-model="searchFilter"/>
      </div>
      <button 
        class="secondary-btn-dark"
        @click="createChallenge();">CREATE NEW CHALLENGE</button>
    </div>

    <div class="tab-body">
      <div class="tab" v-if="selectedCategory === 'all'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('all')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
      <div class="tab" v-if="selectedCategory === 'repeats'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('repeats')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
      <div class="tab" v-if="selectedCategory === 'performance'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('performance')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
      <div class="tab" v-if="selectedCategory === 'social'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('social')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
      <div class="tab" v-if="selectedCategory === 'exercise'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('exercise')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
      <div class="tab" v-if="selectedCategory === 'weight'">
        <DataTable 
          url="v2/manage_challenges"
          :fields="fields"
          :extraParams="extraParams('weight')"
          :options="actionOptions"
          @details-clicked="detailsClicked" />
      </div>
    </div>

    <ChallengeDetailModal
      v-if="viewChallengeDetails || awardingChallenge"/>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import DataTable from '../components/table/DataTable.vue';
import ChallengeDetailModal from '../components/modals/ChallengeDetailModal.vue';

export default {
  name: 'Challenges',

  components: {
    Header,
    DataTable,
    ChallengeDetailModal,
  },

  data() {
    return {
      searchFilter: '',
      selectedCategory: 'all',
      actionOptions: [
        {
          name: 'Edit Challenge',
          action: 'editChallenge',
        },
        {
          name: 'Award Challenge',
          action: 'awardChallenge',
        },
      ],
    };
  },

  methods: {
    changeTab(tab) {
      this.selectedCategory = tab;
    },

    extraParams(category) {
      return {
        'search': this.searchFilter,
        category,
      };
    },

    detailsClicked(event) {
      this.$store.dispatch('challenges/challengeClicked', event);
    },

    createChallenge() {
      this.$router.push({ name: 'ChallengeManagement', params: { creating: true } })
    },
  },

  computed: {
    fields() {
      return [
        {
          name: 'challenge-image-slot',
          title: '',
          sortField: '',
          width: '5%'
        },
        {
          name: 'challenge-name-slot',
          title: 'Name',
          sortField: 'title',
          width: '15%'
        },
        {
          name: "challenge-category-slot",
          title: 'Category',
          sortField: 'category',
        },
        {
          name: "challenge-completed-slot",
          title: 'Completed',
          sortField: 'completed',
        },
        {
          name: 'challenges-actions-slot',
          title: '',
        },
      ]
    },

    viewChallengeDetails: {
      get () {
        return this.$store.state.challenges.viewChallengeDetails
      },
      set (value) {
        this.$store.dispatch('challenges/challengeClicked', value);
      }
    },

    awardingChallenge: {
      get () {
        return this.$store.state.challenges.awardingChallenge
      },
      set (value) {
        this.$store.dispatch('challenges/challengeClicked', value);
      }
    },

  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.tab-container {
  padding: $spacing-base;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    height: 28px;
    display: inline;
    margin-right: 10px;
    
    li {
      float: left;
      padding-left: $spacing-large;
      padding-right: $spacing-large;
      padding-bottom: $spacing-small;
      border-bottom: 3px solid $sec1;
      color: $sec1;
      font-weight: bold;
      font-size: $font-size-base;
      user-select: none;
      cursor: pointer;
    }

    .selected {
      color: $blue;
      border-color: $blue;
    }
  }

  .tab-body {
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }

  .search-field {
    display: inline;
  }

  .secondary-btn-dark {
    float: right;
    border-color: #FFF;
    color: #FFF;
    font-size: 12px;
    height: 28px;
    width: auto;
  }
}
</style>
